import { DatadogEventProcessor } from ".";
import { redactSensitiveData as redactData } from "../../redaction/redactSensitiveData";

/** Redacts sensitive data from all editable fields of a RUM event.
 * https://docs.datadoghq.com/real_user_monitoring/browser/modifying_data_and_context/?tab=npm#modify-the-content-of-a-rum-event
 */
export const redactSensitiveData: DatadogEventProcessor = (event) => {
  event.view.url = redactData(event.view.url);

  if (event.view.referrer) {
    event.view.referrer = redactData(event.view.referrer);
  }

  if (event.type === "error") {
    const { error } = event;
    error.message = redactData(error.message);
    if (error.stack) {
      error.stack = redactData(error.stack);
    }
    if (error.resource) {
      error.resource.url = redactData(error.resource.url);
    }
  }

  if (event.type === "resource") {
    event.resource.url = redactData(event.resource.url);
  }

  if (event.type === "action") {
    if (event.action?.target?.name) {
      event.action.target.name = redactData(event.action.target.name);
    }
  }
};
